module.exports = __webpack_public_path__ + "static/media/pokeball.cf96a89b.png";